export const IS_EMAIL_SUPPORTED_ENABLED = true;

export const TRACKING_CLIENT = {
  DefaultClient: 'DefaultClient',
  SmartPages: 'SmartPages',
};

export const SEGMENT_DATA_TYPES = {
  total: 'total',
  search: 'search',
  social: 'social',
  audience: 'audience',
};

// TODO: update after MT is done
export const GOAL_SETUP_STATUS = {
  ClaritySetupPending: 'ClaritySetupPending',
  None: 'None',
};

export const GOAL_REVENUE_VALUE_MAX = 999999999999.999;
